import Vue from 'vue';
// @ts-ignore
import Vuetify from 'vuetify/lib/framework';
// @ts-ignore
import de from 'vuetify/lib/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#8DB9CA',
        secondary: '#8DB9CA',
        accent: '#8DB9CA',
        error: '#c30000',
        info: '#00a5ff',
        success: '#00c51d',
        warning: '#ecbd00'
      }
    }
  },
  lang: {
    locales: { de },
    current: 'de'
  }
});
